import React, { useState } from 'react';
import theme from './UserDashboard.module.scss';
import { BygrUser, BygrUserDetails } from 'types';
import PrimaryCard from 'components/Statistics/PrimaryCard';
import {
    Button,
    DateDistanceDisplay,
    DateTimeDisplay,
    notEmptyPredicate,
} from '@ygtechnologies/bygr-frontend-component-library';
import EditUserModal from './EditUser';

export interface UserDashboardProps {
    user: BygrUserDetails;
    reload(): void;
}

const languageNames = new Intl.DisplayNames(['en'], {
    type: 'language',
});

export const UserDashboard: React.FC<UserDashboardProps> = ({ user, reload }) => {
    return (
        <div className={theme.dashboardContainer}>
            <PrimaryCard loading={!user}>
                {() => (
                    <>
                        <PrimaryCard.Row label="Name">{user.displayName}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Email">
                            {user.email}
                            <EditUserClick onSave={reload} user={user} />
                        </PrimaryCard.Row>
                        <PrimaryCard.Row label="Phone number">
                            {user.phoneNumber}
                            <EditUserClick onSave={reload} user={user} />
                        </PrimaryCard.Row>
                        <PrimaryCard.Row label="Last visit">
                            {user.lastVisitDate ? <DateDistanceDisplay value={user.lastVisitDate} /> : 'Never'}
                        </PrimaryCard.Row>
                        <PrimaryCard.Row label="Register date">
                            {user.registeredDate ? <DateTimeDisplay value={user.registeredDate} /> : 'N/A'}
                        </PrimaryCard.Row>
                        <PrimaryCard.Row label="Language">{languageNames.of(user.selectedLanguageCode)}</PrimaryCard.Row>
                        <PrimaryCard.Row label="User type">
                            {[user.isSeller ? 'Seller' : null, user.isBuyer ? 'Buyer' : null]
                                .filter(notEmptyPredicate)
                                .join(', ')}
                        </PrimaryCard.Row>
                        {user.isSeller && (
                            <PrimaryCard.Row label="Admin on">
                                {[user.isCmAdmin ? 'CM' : null, user.isAmAdmin ? 'AM' : null, user.isQmAdmin ? 'QM' : null]
                                    .filter(notEmptyPredicate)
                                    .join(', ') || 'No modules'}
                            </PrimaryCard.Row>
                        )}
                    </>
                )}
            </PrimaryCard>
        </div>
    );
};

const EditUserClick: React.FC<{ user: BygrUser; onSave: () => void }> = ({ user, onSave }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <Button color="link" onClick={() => setIsOpen((x) => !x)}>
                Edit
            </Button>
            <EditUserModal onSave={onSave} isOpen={isOpen} user={user} toggle={() => setIsOpen((x) => !x)} />
        </>
    );
};
